<template>
    <div v-if="post.title" class="post">
        <section class="hero">
            <div class="hero-body">
                <img v-if="fimage" :src="fimage" class="img-fluid"/>
                <div class="container" >
                    <div class="row">
                        <h1   v-html="post.title.rendered"></h1>
                        <h2  class="subtitle" v-if="author">
                            Written by <router-link :to="{ name:'Author', params: {authorId: author.id} }">{{ author.name }}</router-link>
                        </h2>
                    </div>
                </div>
            </div>



        </section>

        <div class="content-area">
            <section class="content-container" v-if="post.title" v-html="post.content.rendered">
            </section>
        </div>
    </div>
</template>

<script>
    export default{
        props: ['post', 'author', 'fimage'],

    }
</script>
